import { ContactPersonSourceType } from 'shared';

interface SourceTypeSliderProps {
  value: ContactPersonSourceType;
  onChange: (value: ContactPersonSourceType) => void;
  providerName: string;
  disableImportedOption?: boolean;
}

export function SourceTypeSlider({
  value,
  onChange,
  providerName,
  disableImportedOption,
}: SourceTypeSliderProps) {
  const importedSelected = value === ContactPersonSourceType.IMPORTED;

  return (
    <div className={ `w-full max-w-xl rounded-2xl border border-paidniceGreen-200 bg-paidniceGreen-50 p-1.5` }>
      <div className={ `relative grid grid-cols-2` }>
        <div
          className={ `absolute top-0 bottom-0 w-1/2 rounded-xl bg-white shadow-xs transition-transform duration-200 ease-out ${
            importedSelected ? `translate-x-full` : `translate-x-0`
          }` }
        />
        <button
          type={ `button` }
          className={ `relative z-10 flex flex-col items-center rounded-xl px-4 py-3 text-center transition ${
            !importedSelected ? `text-paidniceGreen-800` : `text-paidniceGray-600 hover:text-paidniceGreen-700`
          }` }
          onClick={ () => onChange(ContactPersonSourceType.LOCAL) }
        >
          <span className={ `text-sm font-semibold` }>{ `Paidnice Only` }</span>
          <span className={ `mt-1 text-xs` }>{ `Saved locally and not synced back` }</span>
        </button>
        <button
          type={ `button` }
          className={ `relative z-10 flex flex-col items-center rounded-xl px-4 py-3 text-center transition ${
            importedSelected ? `text-paidniceGreen-800` : `text-paidniceGray-600 hover:text-paidniceGreen-700`
          } disabled:cursor-not-allowed disabled:text-paidniceGray-400 disabled:hover:text-paidniceGray-400` }
          onClick={ () => onChange(ContactPersonSourceType.IMPORTED) }
          disabled={ disableImportedOption && !importedSelected }
        >
          <span className={ `text-sm font-semibold` }>{ `Sync to ${providerName}` }</span>
          <span className={ `mt-1 text-xs` }>{ `Imported and synced with ${providerName}` }</span>
        </button>
      </div>
    </div>
  );
}
